import { getItems } from 'common/api/countries';

import {
    FETCH_COUNTRIES_ITEMS,
    FETCH_COUNTRIES_ITEMS_FAILURE,
    FETCH_COUNTRIES_ITEMS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    dispatch(actions[FETCH_COUNTRIES_ITEMS]());

    getItems()
        .then((response) =>
            dispatch(
                actions[FETCH_COUNTRIES_ITEMS_SUCCESS](response.data.data),
            ),
        )
        .catch((error) =>
            dispatch(
                actions[FETCH_COUNTRIES_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
